import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_tguegdbkxr: FaireBrandEntity = {
  token: "b_tguegdbkxr",
  type: "brand",
  name: "Beautique Goals",
  avatarUrl:
    "https://cdn.faire.com/fastly/07c04b89ebd38cb4a91fc8d2df084d577100b7c91d4a9ec26181b22d3bebfd75.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/644dfc2066c6d60eb380b1e67624fa15281a05a151d400aeaf8964a6983ea856.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/07c04b89ebd38cb4a91fc8d2df084d577100b7c91d4a9ec26181b22d3bebfd75.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/644dfc2066c6d60eb380b1e67624fa15281a05a151d400aeaf8964a6983ea856.jpeg",
  location: "Denver, CO, USA",
  minimumOrderDollars: 0,
  rating: 4.4,
  reviewCount: 76,
  isInsider: true,
  description:
    "Welcome to Beautique Goals, where mixing up a good time leads to beautiful skin!\n\nOur story began in a kitchen 10 years ago, where the founder, me, and my sweet sister, loved experimenting with natural ingredients to create body butters for fun. We loved the smells and soft feeling the butters had on our skin. So, we starting giving them to friends and family who then raved about our creations, and soon, our hobby turned into a passion project.\n\nAs I perfected the recipes, my sister felt that beauty isn't just about looking good - it's about feeling good, too. She wanted everyone to have access to effective, natural products that make them feel confident and radiant. I agreed and knew it was the right path. We researched, experimented, and bought from trusted brands, small and large to run tests against our formulas.\n\nAnd from that, Beautique Goals was then born! Our products and the products of small businesses we also work with are crafted with love, honest, and designed to help you in all ways from the inside out.\n\nJoin us in our mission to make beauty a fun, feel-good experience for all!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:31.062Z",
    importedBy: "entity-db-cli",
  },
};
